import React from 'react';
import IconBase from './IconBase';

const PrintIcon = props => {
    return (
        <IconBase viewBox={'0 0 40 40'} {...props}>
            <path d="M29.9,11.7H10.1V5h19.9V11.7z M30.5,19.9c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.4-1-0.4s-0.7,0.1-1,0.4c-0.3,0.3-0.4,0.6-0.4,1c0,0.4,0.1,0.7,0.4,1C29.8,19.8,30.1,19.9,30.5,19.9z M27.2,32.2v-7.6H12.8v7.6H27.2z M29.9,35H10.1v-7.1H3.3V17.7c0-1.3,0.4-2.4,1.3-3.3c0.9-0.9,2-1.3,3.3-1.3h24.1c1.3,0,2.4,0.4,3.3,1.3c0.9,0.9,1.3,2,1.3,3.3v10.2h-6.7V35z"/>
        </IconBase>
    )
}

export default PrintIcon;